<template>
    <div v-if="!hasError">
        <div v-if="programChoice === 'CZ02P' || programChoice === 'CZ02S'" class="container image-container">
            <div class="col-lg-12">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.1em;">*</sup>&nbsp;External laboratory tests and internal technical tests - 2020. Compared to the competitor most known lens-brands by consumers (2019 external brand tracking in 11 countries). The word 'overall' refers to anti-reflective coatings important criteria, ranked through an external quantitative consumer study - 2019.</p>
                    <!-- <p>Click the link above to place an order to try Crizal<sup>®</sup> Sapphire<sup>™</sup> HR lenses.</p> -->
                    <p>&nbsp;</p>
                </div>
            </div>
        </div>
        <div v-else-if="checkVariluxXrCoupon" class="container image-container">
            <div class="col-lg-12">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.1em;">1</sup>&nbsp;Based on achieving the highest composite score among premium Progressive designs of leading U.S. competitors on 14 attributes identified as important by a survey of U.S. consumers. Measurements were the result of Essilor R&D state of the art avatar simulations 2022.</p>
                    <p><sup style="letter-spacing: 0.1em;">2</sup>&nbsp;Internal R&D simulations - 2022 - vs Varilux<sup>&reg;</sup> X series<sup>™</sup></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["programChoice", "couponCode", "hasError"],
  computed: {
    checkVariluxXrCoupon() {
        let coupontPretext = this.couponCode.split('-')[0]
        return coupontPretext.includes('VXXR')
    }
  }
};
</script>

<style>
.container.image-container {
    max-width: 100rem;
    display: flex;
    margin: auto;
}
</style>